import { alpha } from '@material-ui/core/styles'; // ----------------------------------------------------------------------

export var Pagination = function Pagination(_ref) {
  var theme = _ref.theme;
  return {
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&$selected': {
            fontWeight: theme.typography.fontWeightBold
          }
        },
        textPrimary: {
          '&$selected': {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.24)
            }
          }
        },
        outlined: {
          border: "1px solid ".concat(theme.palette.grey[50032])
        },
        outlinedPrimary: {
          '&$selected': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            border: "1px solid ".concat(alpha(theme.palette.primary.main, 0.24))
          }
        }
      }
    }
  };
};